import type { CertificateId } from '@engineer-os/engine';

/**
 * The certificates' names and the one sentence every certificate says
 * (docs/certificates.md, "What it may claim"). Shared by the public page and
 * the course, so a certificate cannot be called one thing where it is earned
 * and another where it is checked.
 *
 * The claim is deliberately narrow. It names the account, not a person, and
 * says where the grading happened and against what; it never says who was at
 * the keyboard, and never offers a grade or an hour count the grader did not
 * measure. Widening it is a change to the contract, not to this file.
 */
export const en = {
  names: {
    'version-control': 'Version Control & Collaboration',
    shipping: 'Shipping Software',
    systems: 'Systems',
    'senior-work': 'The Senior Work',
    engineer: 'EngineerOS Certified Engineer',
  } satisfies Record<CertificateId, string>,
  claim: 'This account passed these checkpoints. Each was graded on EngineerOS’s servers, against a repository issued to this account and no other, on the dates shown.',
};

export const ar: typeof en = {
  names: {
    'version-control': 'التحكّم في الإصدارات والعمل الجماعي',
    shipping: 'إطلاق البرمجيات',
    systems: 'الأنظمة',
    'senior-work': 'عمل كبار المهندسين',
    engineer: 'مهندس معتمد من EngineerOS',
  },
  claim: 'اجتاز هذا الحساب هذه المحطات. قُيّمت كلٌّ منها على خوادم EngineerOS، على مستودع صدر لهذا الحساب وحده، في التواريخ المبيّنة.',
};

export const de: typeof en = {
  names: {
    'version-control': 'Versionskontrolle & Zusammenarbeit',
    shipping: 'Software ausliefern',
    systems: 'Systeme',
    'senior-work': 'Die Arbeit auf Senior-Niveau',
    engineer: 'EngineerOS Certified Engineer',
  },
  claim: 'Dieses Konto hat diese Checkpoints bestanden. Jeder wurde auf den Servern von EngineerOS bewertet, anhand eines Repositorys, das nur für dieses Konto ausgestellt wurde, an den angegebenen Tagen.',
};

export const ja: typeof en = {
  names: {
    'version-control': 'バージョン管理とコラボレーション',
    shipping: 'ソフトウェアのリリース',
    systems: 'システム',
    'senior-work': 'シニアの仕事',
    engineer: 'EngineerOS Certified Engineer',
  },
  claim: 'このアカウントは、これらのチェックポイントに合格しています。それぞれ、このアカウントだけに発行されたリポジトリを対象に、EngineerOSのサーバーで、表示された日付に採点されました。',
};
